/**
 * Created by Alex Aguilar on 4/1/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('makerService',makerService);

    makerService.$inject = ['$http', 'CONFIG','messageService'];

    function makerService($http, CONFIG,messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/makers';

        var service = {
            getMakers: getMakers,
            getPageMakers: getPageMakers,
            getMaker: getMaker,
            saveMaker: saveMaker,
            updateMaker: updateMaker,
            deleteMaker: deleteMaker,
            thereNameMaker: thereNameMaker
        }

        return service;

        function getMakers(){
            return $http.get(urlBase + '/list')
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function getPageMakers(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function getMaker(id){
            return $http.get(urlBase + "/" + id)
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findError('makerList');
                });
        }

        function saveMaker(maker, redirect){
            var params = (redirect != null) ? 'makerList' : '';
            return $http.post(urlBase, maker)
                .then(function (response) {
                    messageService.register(params);
                    return response;
                })
                .catch(function () {
                    messageService.registerError(params);
                });
        }

        function updateMaker(maker, makerId){
            return $http.put(urlBase + "/" + makerId, maker)
                .then(function(){
                    messageService.registerUpdate('makerList');
                }, function(){
                    messageService.registerUpdateError('makerList');
                });
        }

        function deleteMaker(makerId){
            return $http.delete(urlBase + "/" + makerId)
                .then(function(response){
                    messageService.registerDelete('makerList');
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('makerList','air.maker.associatedModelAircrafts');
                    }else{
                        messageService.registerDeleteError('makerList')
                    }
                });
        }

        function thereNameMaker(name){
            return $http.get(urlBase + "/thereNameMaker/" + name, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }
    }
})();

